/*
 * Keyboard and screen reader support for the diamond search range sliders (ion.rangeSlider 2.3.1).
 *
 * ion.rangeSlider only renders styled <span>s, so on its own a slider has no role, no value,
 * no name and its handles cannot be reached with the keyboard.
 * This script leaves ion's markup and the theme's slider setup untouched and adds:
 *   - role="slider" + tabindex="0" + aria-label / aria-valuemin / aria-valuemax / aria-valuenow / aria-valuetext on each handle
 *   - Arrow keys (+/- one step), PageUp/PageDown (about 10% of the range), Home/End on the focused handle
 *   - the same filtering call as a mouse drag (ion's onFinish), debounced so a held key does not flood the API
 *   - aria-hidden on ion's hidden <input> (a readonly, tabindex=-1 value holder that has no label)
 *
 * Load it right AFTER ion.rangeSlider.min.js and the script that creates the sliders, in the same
 * jQuery context: ion stores its instances in the jQuery that was current when ion loaded.
 */
(function () {
  var $j = window.jQuery;
  if (!$j || !$j.fn || !$j.fn.ionRangeSlider) return;

  var MIN_SUFFIX = ' minimum';
  var MAX_SUFFIX = ' maximum';
  var FINISH_DELAY = 400;

  function instanceOf(input) {
    return $j(input).data('ionRangeSlider');
  }

  function labelFor(input) {
    var block = input.closest('.vdb_gs-filter_block');
    var span = block && block.querySelector('.vd_gs-lable > span');
    var text = span && span.textContent.replace(/\s+/g, ' ').trim();
    return text || (input.name || input.id || 'Range').replace(/^(lab_grown|natural)_/, '').replace(/_/g, ' ');
  }

  function decimals(step) {
    var parts = String(step).split('.');
    return parts[1] ? parts[1].length : 0;
  }

  function text(el, fallback) {
    var t = el && el.textContent.trim();
    return t ? t : String(fallback);
  }

  function setAttrs(el, attrs) {
    for (var k in attrs) {
      if (el.getAttribute(k) !== String(attrs[k])) el.setAttribute(k, attrs[k]);
    }
  }

  // Applies role, name and current values to the handles of one slider.
  function sync(input) {
    var inst = instanceOf(input);
    var cont = inst && inst.$cache && inst.$cache.cont && inst.$cache.cont[0];
    if (!cont || !input.isConnected) return;

    if (input.getAttribute('aria-hidden') !== 'true') input.setAttribute('aria-hidden', 'true');

    var line = cont.querySelector('.irs-line');
    if (line && line.getAttribute('tabindex') !== '-1') line.setAttribute('tabindex', '-1');

    var o = inst.options;
    var r = inst.result;
    var name = labelFor(input);
    var isDouble = o.type === 'double';
    var fromEl = cont.querySelector('.irs-handle.from') || cont.querySelector('.irs-handle.single');
    var toEl = isDouble ? cont.querySelector('.irs-handle.to') : null;
    var fromText = text(cont.querySelector('.irs-from'), r.from);
    var toText = text(cont.querySelector('.irs-to'), r.to);
    var singleText = isDouble ? '' : text(cont.querySelector('.irs-single'), r.from);

    if (fromEl) {
      setAttrs(fromEl, {
        role: 'slider',
        tabindex: '0',
        'aria-label': isDouble ? name + MIN_SUFFIX : name,
        'aria-valuemin': o.min,
        'aria-valuemax': isDouble ? r.to : o.max,
        'aria-valuenow': r.from,
        'aria-valuetext': isDouble ? fromText : singleText,
      });
    }
    if (toEl) {
      setAttrs(toEl, {
        role: 'slider',
        tabindex: '0',
        'aria-label': name + MAX_SUFFIX,
        'aria-valuemin': r.from,
        'aria-valuemax': o.max,
        'aria-valuenow': r.to,
        'aria-valuetext': toText,
      });
    }
  }

  function syncAll() {
    var inputs = document.querySelectorAll('input.js-range-slider');
    for (var i = 0; i < inputs.length; i++) sync(inputs[i]);
  }

  // ion re-creates its markup on every update() and rewrites the labels while dragging,
  // so keep the attributes in step with DOM changes (batched to one run per frame).
  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      syncAll();
    });
  }

  function start() {
    syncAll();
    new MutationObserver(queueSync).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function onKeydown(e) {
    var handle = e.target;
    if (!handle || !handle.matches || !handle.matches('.irs-handle[role="slider"]')) return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;

    var cont = handle.closest('.irs');
    var input = cont && cont.nextElementSibling;
    var inst = input && instanceOf(input);
    if (!inst) return;

    var o = inst.options;
    var r = inst.result;
    var min = o.min;
    var max = o.max;
    var step = o.step || 1;
    var large = Math.max(step, Math.round((max - min) / 10 / step) * step);
    var isDouble = o.type === 'double';
    var which = handle.classList.contains('to') ? 'to' : 'from';
    var current = which === 'to' ? r.to : r.from;
    var lower = which === 'to' ? r.from : min;
    var upper = which === 'from' && isDouble ? r.to : max;
    var next;

    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowUp':
        next = current + step;
        break;
      case 'ArrowLeft':
      case 'ArrowDown':
        next = current - step;
        break;
      case 'PageUp':
        next = current + large;
        break;
      case 'PageDown':
        next = current - large;
        break;
      case 'Home':
        next = lower;
        break;
      case 'End':
        next = upper;
        break;
      default:
        return;
    }
    e.preventDefault();

    next = +Math.min(upper, Math.max(lower, next)).toFixed(decimals(step));
    if (next === current) return;

    var update = {};
    if (which === 'to') {
      update.from = r.from;
      update.to = next;
    } else {
      update.from = next;
      if (isDouble) update.to = r.to;
    }
    inst.update(update);

    // update() rebuilds the slider markup, so put focus back on the matching handle.
    var newCont = inst.$cache.cont[0];
    var newHandle = newCont && (newCont.querySelector('.irs-handle.' + which) || newCont.querySelector('.irs-handle.single'));
    sync(input);
    if (newHandle) newHandle.focus();

    // Same filtering call as the end of a mouse drag, once the key presses stop.
    clearTimeout(input._vdbSliderFinishTimer);
    input._vdbSliderFinishTimer = setTimeout(function () {
      var current = instanceOf(input);
      if (current && typeof current.callOnFinish === 'function') current.callOnFinish();
    }, FINISH_DELAY);
  }

  document.addEventListener('keydown', onKeydown);

  /*
   * Shape tiles, cut circles and the "advanced filters" toggle are plain <div>/<span> elements that
   * vdb-collection.js drives with click listeners and an `active` class (toggle behaviour: clicking the
   * active one clears it). Make them keyboard operable buttons without touching that script:
   *   - role="button" + tabindex="0"; the accessible name is the visible text
   *     (cut circles only show "1", "2", "3", so they are named from the caption above them: "Excellent (1)")
   *   - aria-pressed mirrors the selected class (`active`, or the server-side `is-active-shape`, both are styled as selected)
   *   - the advanced toggle gets aria-expanded from its data-filter ("close" = panel open, "open" = panel closed)
   *   - Enter / Space dispatch the same click VDB listens for
   *   - the advanced panel sits before its toggle in the DOM, so opening it from the keyboard moves focus
   *     to its first control (otherwise Tab would continue past the new filters)
   */
  var TILE_SEL = '.vdb_gs-diamond-shape-item, .vdb_gs-cut-selector';
  var ADV_SEL = '#vdb-gs-advanced-filter-view';
  // Captions above the cut circles ("Excellent", "Too Shallow", "Too Deep"), one per circle.
  var CUT_CAPTIONS = {
    lab_grown_cut_selectors: '.vdb_gs-lab-grown-diamond-cut-item',
    natural_cut_selectors: '.vdb_gs-natural-diamond-cut-item',
  };

  // "Excellent (1)" when the captions line up with the circles, otherwise "Cut 1".
  function cutName(el) {
    var n = (el.textContent || '').trim();
    var box = el.closest('.vdb_gs-cut-selectors-container');
    var sel = box && CUT_CAPTIONS[box.id];
    if (!sel) return 'Cut ' + n;
    var scope = box;
    while (scope && !scope.querySelector(sel)) scope = scope.parentElement;
    var captions = scope ? scope.querySelectorAll(sel) : [];
    var circles = box.querySelectorAll('.vdb_gs-cut-selector');
    var i = Array.prototype.indexOf.call(circles, el);
    return captions.length === circles.length && i > -1 ? captions[i].textContent.trim() + ' (' + n + ')' : 'Cut ' + n;
  }

  function focusFirstAdvanced() {
    var panels = document.querySelectorAll('.advance-filter-web:not(.hide)');
    for (var p = 0; p < panels.length; p++) {
      var items = panels[p].querySelectorAll('[tabindex], a[href], button, input, select');
      for (var j = 0; j < items.length; j++) {
        if (items[j].tabIndex >= 0 && !items[j].disabled && items[j].offsetParent) {
          items[j].focus();
          return;
        }
      }
    }
  }

  function syncButton(el, attrs) {
    if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    setAttrs(el, attrs);
  }

  function syncButtons() {
    var tiles = document.querySelectorAll(TILE_SEL);
    for (var i = 0; i < tiles.length; i++) {
      var cl = tiles[i].classList;
      var attrs = { 'aria-pressed': cl.contains('active') || cl.contains('is-active-shape') ? 'true' : 'false' };
      if (cl.contains('vdb_gs-cut-selector')) attrs['aria-label'] = cutName(tiles[i]);
      syncButton(tiles[i], attrs);
    }
    var adv = document.querySelector(ADV_SEL);
    if (adv) syncButton(adv, { 'aria-expanded': adv.getAttribute('data-filter') === 'close' ? 'true' : 'false' });
  }

  var buttonsQueued = false;
  function queueSyncButtons() {
    if (buttonsQueued) return;
    buttonsQueued = true;
    requestAnimationFrame(function () {
      buttonsQueued = false;
      syncButtons();
    });
  }

  function startButtons() {
    syncButtons();
    // Class / data-filter changes (selection, panel toggle) and re-rendered markup.
    new MutationObserver(queueSyncButtons).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-filter'],
    });
  }

  document.addEventListener('keydown', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(TILE_SEL + ', ' + ADV_SEL)) return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      el.click();
      // VDB shows the panel synchronously on click; wait a frame so the handles have layout.
      if (el.matches(ADV_SEL) && el.getAttribute('data-filter') === 'close') requestAnimationFrame(focusFirstAdvanced);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startButtons);
  } else {
    startButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
